






































import {
  defineComponent,
  useRouter,
  useContext,
  computed,
} from "@nuxtjs/composition-api";
import { useUser } from "@wemade-vsf/customer";
import { useUiState } from "@wemade-vsf/composables";
import { SfButton } from "@storefront-ui/vue";
import DropdownMenu from "components/theme/UI/DropdownMenu.vue";
import type { MenuItem } from "components/theme/UI/DropdownMenu.vue";

export default defineComponent({
  name: "AccountIcon",
  components: {
    SfButton,
    DropdownMenu,
  },
  props: {
    icon: {
      type: String,
      default: "user",
    },
    loggedInIcon: {
      type: String,
      default: "circle-user",
    },
    iconHeight: {
      type: String,
      default: "27",
    },
    iconWidth: {
      type: String,
      default: "27",
    },
  },
  setup(props) {
    const { app, i18n } = useContext();
    const router = useRouter();
    const { isAuthenticated, user, logout } = useUser();
    const { toggleLoginModal } = useUiState();
    const linkText = computed(() => {
      return isAuthenticated.value && user.value
        ? i18n.t("My User Account")
        : i18n.t("Login");
    });

    const handleAccountClick = async () => {
      if (isAuthenticated.value) {
        await router.push(app.localeRoute({ name: "customer-my-profile" }));
      } else {
        toggleLoginModal();
      }
    };

    const accountIcon = computed(() => {
      return isAuthenticated.value ? props.loggedInIcon : props.icon;
    });

    const defaultMenuGroups = [
      [
        {
          label: "My Profile",
          to: { name: "customer-my-profile" },
        },
        {
          label: "Addresses details",
          to: { name: "customer-addresses-details" },
        },
        {
          label: "Order history",
          to: { name: "customer-order-history" },
        },
      ],
    ];

    const logoutGroup = [
      {
        label: "Log out",
        icon: "arrow-right-from-bracket",
        click: async () => {
          await logout({});
          document.cookie = 'vsf-customer=; Max-Age=0; path=/;';
          document.cookie = 'customer-token=; Max-Age=0; path=/;';
          const currentPath = router.currentRoute.fullPath || '';
          if (currentPath.includes('checkout') || currentPath.includes('svea')) {
            window.location.href = app.localeRoute({ name: 'home' }).fullPath;
          } else {
            window.location.reload();
          }
        },
      },
    ];

    const menuGroups = computed(() => {
      const injected: MenuItem[][] | undefined =
        app.$wm.customer?.accountMenuGroups;
      if (injected?.length) {
        return [...injected, logoutGroup];
      }
      return [...defaultMenuGroups, logoutGroup];
    });

    return {
      handleAccountClick,
      isAuthenticated,
      linkText,
      accountIcon,
      menuGroups,
    };
  },
});
